import React from 'react'
import PropTypes from 'prop-types'

const VideoToggle = props => {
  const renderLabel = () => {
    if (props.label) {
      if (typeof props.label === 'string') {
        return <strong>{props.label}</strong>
      } else {
        return <strong>Video Selected:</strong>
      }
    }
  }

  let videoTitle = props.video.title
  if (props.durationInTitle) {
    videoTitle += props.video.human_duration
  }

  return (
    <p>
      {renderLabel()}
      <a
        href='#'
        className='admin-preview-video-toggle'
        onClick={props.handleClick}
      >
        {videoTitle}
      </a>
    </p>
  )
}

VideoToggle.propTypes = {
  durationInTitle: PropTypes.bool,
  handleClick: PropTypes.func,
  label: PropTypes.string,
  video: PropTypes.object
}

export default VideoToggle
